import {
  GET_LANGUAGES_START,
  GET_LANGUAGES_FINISH,
  GET_LANGUAGES_ERROR,
  CHANGE_LANGUAGE,
} from "store/actionTypes/language";
import apiEndpoints from "constants/endpoints";
import { apiRequest } from "api-client";

export const getLanguagues = () => {
  return (dispatch) => {
    dispatch({
      type: GET_LANGUAGES_START,
    });
    apiRequest.get(`${apiEndpoints.languages}`)
      .then((data) => {
        dispatch({
          type: GET_LANGUAGES_FINISH,
          payload: data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_LANGUAGES_ERROR,
          payload: err,
        });
      });
  };
};

export const changeLanguage = (lang) => ({
  type: CHANGE_LANGUAGE,
  payload: lang,
});